export default {
    EXAMPLE: 'example',
};
